(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-hb-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-hb-track]');
      const slides = [...gallery.querySelectorAll('[data-hb-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-hb-thumbnail]')];
      let current = 0;
      const show = index => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        track.style.transform = `translateX(-${current * 100}%)`;
        slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== current)));
        thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === current); thumb.setAttribute('aria-selected', String(i === current)); });
        gallery.querySelector('[data-hb-status]').textContent = `${current + 1} / ${slides.length}`;
        gallery.querySelector('[data-hb-prev]').disabled = current === 0;
        gallery.querySelector('[data-hb-next]').disabled = current === slides.length - 1;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      gallery.querySelector('[data-hb-prev]').addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-hb-next]').addEventListener('click', () => show(current + 1));
      let start = 0;
      track.addEventListener('touchstart', event => { start = event.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', event => { const delta = start - event.changedTouches[0].clientX; if (Math.abs(delta) > 40) show(current + (delta > 0 ? 1 : -1)); }, { passive: true });
      show(0);
    });
    scope.querySelectorAll('button[aria-controls]:not([data-footer-trigger])').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    });
    scope.querySelectorAll('[data-footer-trigger]').forEach(trigger => {
      if (trigger.dataset.ready) return;
      trigger.dataset.ready = 'true';
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      let mobile;
      const update = () => {
        const next = window.innerWidth < 768;
        if (next === mobile) return;
        mobile = next;
        panel.hidden = mobile;
        trigger.setAttribute('aria-expanded', String(!mobile));
      };
      trigger.addEventListener('click', () => {
        if (!mobile) return;
        panel.hidden = !panel.hidden;
        trigger.setAttribute('aria-expanded', String(!panel.hidden));
      });
      window.addEventListener('resize', update);
      update();
    });
    scope.querySelectorAll('[data-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-carousel-track]');
      carousel.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(button => button.addEventListener('click', () => track.scrollBy({ left: (button.hasAttribute('data-carousel-next') ? 1 : -1) * track.clientWidth, behavior: 'smooth' })));
    });
    scope.querySelectorAll('.lmcd-hero-bible__review-grid').forEach(grid => {
      if (grid.dataset.ready) return;
      grid.dataset.ready = 'true';
      const cards = [...grid.querySelectorAll('[data-hb-customer-review]')];
      if (!cards.length) return;
      const gap = 12;
      const layout = () => {
        const columns = window.innerWidth <= 640 ? 2 : window.innerWidth <= 900 ? 3 : 5;
        const width = (grid.clientWidth - gap * (columns - 1)) / columns;
        if (!width) return;
        const heights = Array(columns).fill(0);
        cards.forEach(card => {
          const column = heights.indexOf(Math.min(...heights));
          card.style.position = 'absolute';
          card.style.left = `${column * (width + gap)}px`;
          card.style.top = `${heights[column]}px`;
          card.style.width = `${width}px`;
          heights[column] += card.getBoundingClientRect().height + gap;
        });
        grid.style.height = `${Math.max(...heights)}px`;
      };
      cards.forEach(card => card.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', layout, { once: true }); }));
      window.addEventListener('resize', layout);
      window.addEventListener('load', layout, { once: true });
      if (document.fonts?.ready) document.fonts.ready.then(layout);
      layout();
    });
    scope.querySelectorAll('[data-fb-video]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const video = card.querySelector('video');
      const button = card.querySelector('[data-hb-sound-toggle]');
      video.muted = true;
      if (button) button.addEventListener('click', () => {
        video.muted = !video.muted;
        button.setAttribute('aria-pressed', String(!video.muted));
        button.setAttribute('aria-label', video.muted ? 'Play video with sound' : 'Mute video');
        button.querySelector('span').textContent = video.muted ? 'Tap for sound' : 'Sound on';
        video.play().catch(() => {});
      });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) video.play().catch(() => {}); else video.pause();
        }), { threshold: 0.3 });
        observer.observe(video);
      }
    });
    const form = document.getElementById('lmcd-charles-stanley-primary-form');
    scope.querySelectorAll('[data-hb-sticky-purchase]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => { const add = form?.querySelector('[type=submit]'); if (add) add.click(); });
    });
    const sticky = document.querySelector('[data-hb-sticky-cta]');
    if (sticky && form && !sticky.dataset.observed) {
      sticky.dataset.observed = 'true';
      const footer = document.querySelector('[data-hb-footer]');
      const update = () => {
        const past = form.getBoundingClientRect().bottom <= 0;
        const nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        sticky.hidden = !past || nearFooter;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
